<template>
  <edit-page
    :aspect-menu-items="aspectMenuItems"
    :errors="errors"
    :log-entries="model.logEntries"
    :model="model"
    :toasts="toasts"
  >
  </edit-page>
</template>

<script>
import EditPage from '@kanrisha/Pages/Models/Edit';

export default {
  components: {
    EditPage,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    meta: { type: Object, default: () => {} },
    logEntries: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  setup() {
    return {};
  },
};
</script>
